(function () {
    const initSlider = () => {
        let productSlider;
        const productSliders = document.querySelectorAll('.product-recommendations__swiper');
        productSliders.forEach((slider, index) => {
            productSlider = new Swiper(slider, {
                navigation: {
                    nextEl: ".product-recommendations__button-next",
                    prevEl: ".product-recommendations__button-prev",
                },
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 8,
                breakpoints: {
                768: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: 6,
                }
            }
            });
        });
    };
    const destroySlider = () => {
        const productSliders = document.querySelectorAll('.product-recommendations__swiper');
        productSliders.forEach((slider, index) => {
            if (slider.swiper !== undefined) slider.swiper.destroy();
        });
    };
    const initSection = () => {
        const sections = document.querySelectorAll('.section-product-recommendations');
        const sectionResizeObserver = new ResizeObserver((entries) => {
            destroySlider();
            initSlider();
        });
        destroySlider();
        initSlider();
        sections.forEach(item => {
            sectionResizeObserver.observe(item);
        });
    };
    initSection();
    document.addEventListener('shopify:section:load', function () {
        initSection();
    });
})();